import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { P00032PositionType } from '../../../P00032/Enum/P00032PositionType';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import { P00043PositionType } from '../../Enum/P00043PositionType';
import { P00043SensContactSelEnum } from '../../Enum/P00043SensContactSelEnum';

@Component({
  selector: 'app-p00043-installation-sortie-pilotage',
  templateUrl: './p00043-installation-sortie-pilotage.component.html',
  styleUrls: ['./p00043-installation-sortie-pilotage.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    TranslatePipe,
    LabelDescriptionComponent,
    LargedLinkComponent,
    InformationTitleComponent,
  ],
})
export class P00043InstallationSortiePilotageComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private modalController: ModalController = inject(ModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  positionRaccordement: number | undefined = undefined;

  constructor() {}

  async openPositionRaccordementModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00043.modal.positionraccordement.title',
        value: this.positionRaccordement,
        firstChoice: {
          title: 'P00043.modal.positionraccordement.option0',
          image:
            '/assets/ecosystem/images/products/P00043/P00043-position-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00043.modal.positionraccordement.option1',
          image:
            '/assets/ecosystem/images/products/P00043/P00043-position-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.positionRaccordement = data.value;
    }
  }

  async openPositionModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00043.modal.senscontactsel.title',
        value: this.actionStack!.getValue('paISensContactSec'),
        firstChoice: {
          title: 'P00043.modal.senscontactsel.option0',
          image:
            '/assets/ecosystem/images/products/P00043/P00043-senscontact-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00043.modal.senscontactsel.option1',
          image:
            '/assets/ecosystem/images/products/P00043/P00043-senscontact-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PAC_Installation,
        'paISensContactSec',
        data.value,
        null,
      );
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.positionRaccordement =
      this.poolAdditionalData?.positionRaccordementPAC ?? 0;
  }

  onSubmit() {
    this.poolAdditionalData!.positionRaccordementPAC =
      this.positionRaccordement!;
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00032PositionType = P00032PositionType;
  protected readonly P00043PositionType = P00043PositionType;
  protected readonly P00043SensContactSelEnum = P00043SensContactSelEnum;
}
